import React from "react";
import {
  Redirect,
  Route,
  Switch,
  RouteComponentProps,
  RouteProps as RoutePropsBase,
  useLocation,
} from "react-router-dom";

import { routes as preferencesRoutes } from "./Preferences";
import { routes as youAndUsRoutes } from "./YouAndUs";

import { AccountForm } from "../../forms/AccountForm";
import { SendPasswordResetEmailForm } from "../../forms/SendPasswordResetEmailForm";
import { SignInForm } from "../../forms/SignInForm";
import { SignInWithQR } from "../SignInWithQR";
import { SignOutPage } from "../SignOut";
import { SignUpForm } from "../../forms/SignUpForm";

const publicRoutes = [
  ...preferencesRoutes,
  ...youAndUsRoutes,
];

interface RouteProps extends RoutePropsBase {
  path: string;
}

const authorizedRoutes: RouteProps[] = [
  { path: "account", component: AccountForm, exact: true },
  { path: "sign-out", component: SignOutPage, },
];

const unauthorizedRoutes: RouteProps[] = [
  { path: "sign-in", component: SignInForm, },
  { path: "sign-up", component: SignUpForm, },
  { path: "qr", component: SignInWithQR },
  { path: "send-reset-link", component: SendPasswordResetEmailForm, },
];

interface IProps extends Pick<RouteComponentProps, "match"> {
  isLogin: boolean;
}

export const Main: React.FC<IProps> = ({ isLogin, match }) => {
  const location = useLocation();

  const routes = [
    ...publicRoutes,
    ...(isLogin ? authorizedRoutes : unauthorizedRoutes)
  ];

  return (
    <Switch>
      {
        routes.map(({ path, component }) => (
          <Route key={path} path={`${match.path}/${path}`} component={component} />
        ))
      }

      <Redirect
        to={{
          ...location,
          pathname: `${match.url}/${isLogin ? "account" : "sign-in"}`,
        }}
      />
    </Switch>
  );
};
